import React, { useRef, useState } from "react";
import { FaPlayCircle } from "react-icons/fa";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
// import "./HowToRegister.css";

const HowToRegister = () => {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const token = Cookies.get("token");
  if (token) return null;

  const handlePlayVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoPauseOrEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="how-to-main-section-wrapper">
      <div className="how-to-inner-container">
        {/* --- Header Section --- */}
        <div className="how-to-text-center">
          <h1 className="how-to-title">
            {t("how_to")}{" "}
            <span className="how-to-blue-accent">
              {t("Register")}
              <svg
                className="how-to-wave-underline"
                width="100%"
                height="10"
                viewBox="0 0 100 10"
                preserveAspectRatio="none"
              >
                <path
                  d="M0 5 Q 25 0, 50 5 T 100 5"
                  fill="none"
                  stroke="#2173d1"
                  strokeWidth="3"
                />
              </svg>
            </span>
          </h1>
          <p className="how-to-description">
            Step-by-step guide to start exploring Arabian & Thoroughbred
            <br />
            horse racing stats! Register now and never miss a race!
          </p>
        </div>

        {/* --- Video Section with White Frame --- */}
        <div className="how-to-video-card-frame">
          <div
            className="how-to-video-inner-box"
            style={{ position: "relative" }}
          >
            <iframe
              width="100%"
              height="500"
              src="https://www.youtube.com/embed/D6sA6Stk0Oc"
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>

            {/* Custom Play Button Overlay - Sirf tab dikhega jab video stop ho */}
            {/* {!isPlaying && (
              <div className="how-to-play-overlay" onClick={handlePlayVideo}>
                <div className="play-button-circle">
                  <div className="play-icon-triangle"></div>
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToRegister;
